(function ($) {
  'use strict';

  $(document).ready(init);

  function init() {
    if (!$('.paragraph-visual-lane').length) {
      return;
    }

    var $backgroundItem = $('.paragraph-visual-lane__slides-item');
    if ($backgroundItem.length < 2) {
      return;
    }

    setTransformOrigin($backgroundItem);
    createBackgroundCarousel($backgroundItem);
    // setPageColor($backgroundItem);
  }

  function setTransformOrigin($item) {
    $item.each(function () {
      var $item = $(this);
      var $image = $item.find('img');

      var posX = $image.data('focal-x');
      var posY = $image.data('focal-y');

      $item.css('transform-origin', posX * 10 + '%' + posY * 10 + '%');
    });
  }

  function createBackgroundCarousel($slide) {
    var activeClass = 'paragraph-visual-lane__slides-item--active';
    $slide.not(':last').hide();
    var $firstSlide = $slide.last();
    var $page = $('.page');
    $firstSlide.addClass(activeClass);
    $page.addClass('page--' + getColor($firstSlide));

    var $backgroundContainer = $slide.parent();
    setInterval(function () {
      var $currentSlide = $backgroundContainer.children().last();
      var $nextSlide = $currentSlide.prev();
      var currentColor = getColor($currentSlide);
      var nextColor = getColor($nextSlide);

      $page.removeClass('page--' + currentColor).addClass('page--' + nextColor);

      $currentSlide.fadeOut(1000, function () {
        $(this).removeClass(activeClass);
        $currentSlide.prependTo($backgroundContainer);
      });

      $nextSlide.addClass(activeClass);
      $nextSlide.fadeIn(1000);
    }, 6000);
  }

  function getColor($item) {
    return $item.attr('data-color');
  }

})(jQuery);
